import { useRegisterModuleNavigation } from '@/hooks/useRegisterModuleNavigation';

import { peopleNavigationItems } from '../navigation';

export function usePeopleModuleNavigation() {
    useRegisterModuleNavigation({
        moduleId: 'people',
        displayName: 'Pessoas',
        items: peopleNavigationItems,
    });
}
